import { useTranslation } from "react-i18next";
import {
  UsersThree,
  ChartBar,
  Receipt,
  Lightning,
} from "@phosphor-icons/react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const ITEMS = [
  { icon: UsersThree, key: "1" },
  { icon: ChartBar, key: "2" },
  { icon: Receipt, key: "3" },
  { icon: Lightning, key: "4" },
] as const;

export function Benefits() {
  const ref = useScrollReveal<HTMLElement>();
  const { t } = useTranslation();

  return (
    <section
      ref={ref}
      id="benefits"
      className="animate-on-scroll bg-white py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Editorial header */}
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-8">
          <div className="col-span-12 lg:col-span-5">
            <h2 className="font-heading text-3xl leading-[1.1] font-bold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
              {t("forCompaniesPage.benefits.title")}
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-6 lg:col-start-7 lg:self-end">
            <p className="max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
              {t("forCompaniesPage.benefits.subtitle")}
            </p>
          </div>
        </div>

        {/* Benefit cards */}
        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-2xl sm:grid-cols-2"
          style={{ background: "var(--color-warm-border)", border: "1px solid var(--color-warm-border)" }}
        >
          {ITEMS.map(({ icon: Icon, key }, i) => (
            <article
              key={key}
              className="group relative bg-white p-8 transition-colors duration-300 hover:bg-[oklch(98%_0.012_84)] sm:p-9"
            >
              <div className="relative z-10">
                <span
                  className="inline-flex size-10 items-center justify-center rounded-full"
                  style={{
                    background: "var(--color-brand-bg-light)",
                    color: "var(--color-brand-dark)",
                  }}
                >
                  <Icon className="size-5" weight="duotone" />
                </span>

                <h3 className="font-heading mt-6 text-xl font-semibold leading-tight tracking-tight text-foreground sm:text-2xl">
                  {t(`forCompaniesPage.benefits.item${i + 1}Title`)}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-[15px]">
                  {t(`forCompaniesPage.benefits.item${i + 1}Desc`)}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
